import PropTypes from 'prop-types'
import { useState } from 'react'
import Precios from '../../reutilizables/precios/Precios'
import styles from './Pedido.module.css'
import { PedidoBody } from './PedidoBody'

export const PedidoItem = ({
  pedidoItem,
  fechaPedido,
  isFirstItem,
  esVentas,
  tienePercepcionesPendientes,
  esAdministrador
}) => {
  const { titulo, monedaSimbolo } = pedidoItem
  const [verDetalle, setVerDetalle] = useState(isFirstItem)

  const handleClickFlecha = () => {
    setVerDetalle(!verDetalle)
  }

  const obtenerClasesFlechas = () => {
    let claseFlecha = 'fa fa-caret-'
    claseFlecha += verDetalle ? 'down' : 'right'
    return claseFlecha
  }
  return (
    <div className={styles.pedidoItem}>
      <div className={styles.cabecera}>
        <div onClick={handleClickFlecha} style={{ cursor: 'pointer' }}>
          {titulo}
          <i className={obtenerClasesFlechas()} aria-hidden="true" />
        </div>
        <Precios
          precio={pedidoItem.precioUnitario}
          monedaSimbolo={monedaSimbolo}
          alicuota={pedidoItem.alicuota}
          cantidad={pedidoItem.cantidad || 1}
          mostrarCantidad
          showSinIVA={true}
        />
      </div>
      {verDetalle && (
        <PedidoBody
          fechaPedido={fechaPedido}
          pedidoItem={pedidoItem}
          esVentas={esVentas}
          tienePercepcionesPendientes={tienePercepcionesPendientes}
          esAdministrador={esAdministrador}
        />
      )}
    </div>
  )
}

PedidoItem.propTypes = {
  pedidoItem: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    monedaSimbolo: PropTypes.string.isRequired,
    cantidad: PropTypes.number,
    alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired,
  fechaPedido: PropTypes.string.isRequired,
  isFirstItem: PropTypes.bool.isRequired,
  esVentas: PropTypes.bool.isRequired,
  tienePercepcionesPendientes: PropTypes.bool.isRequired,
  esAdministrador: PropTypes.bool.isRequired
}
